import React from "react";

import PageContainer from "../../components/common/PageContainer";
import Card from "../../components/ui/Card";
import SectionCard from "../../components/ui/SectionCard";
import AgentHeader from "../../components/agents/AgentHeader";
import InfoItem from "../../components/ui/InfoItem";

import {
  ChartGantt,
  Clock,
  BadgeIndianRupee as BadgeIndianRupeeIcon,
  Mic,
  User,
  Building2,
  Mail,
  Phone,
  ChartNoAxesCombined as ChartNoAxesCombinedIcon,
  Calendar,
} from "lucide-react";

import { agentUsageData } from "../../data/agentUsageMock";

import AgentUseageChart from "../../components/agents/useage/AgentUseageChart";

import "../../styles/VoiceUsage.css";

export default function AgentUsagePage() {
  const { agent, plan, usage, billing, billingCycle, status } =
    agentUsageData;

  return (
    <PageContainer>
      <div className="agent-usage-page">
        <div className="agent-usage-header">
        <AgentHeader />
        </div>
        {/* Header */}

                {/* Agent Info */}
                <SectionCard title="Agent Basic Info" icon={User}>
          <Card className="max-w-0 m-0">
            <div className="d-flex align-center gap-2 mb-2">
              <h2 className="agent-title">{agent.name}</h2>

              <span className="agent-industry">
                <Building2 size={14} />
                {agent.industry}
              </span>
            </div>

            <div className="agent-grid">
              <InfoItem icon={Mail} label="Email">
                {agent.email}
              </InfoItem>

              <InfoItem icon={Phone} label="Mobile">
                {agent.mobile}
              </InfoItem>

              <InfoItem icon={Building2} label="Industry">
                {agent.industry}
              </InfoItem>

              <InfoItem icon={Calendar} label="Created">
                {agent.createdAt}
              </InfoItem>
            </div>
          </Card>
        </SectionCard>
        <header>
          <div className="d-flex justify-between align-center mb-1">
            <div>
              <span className="d-flex align-center gap-2">
                <Mic size={33} />

                <h1 className="text-lg fw-semibold text-primary">
                  Voice Usage
                </h1>
              </span>

              <p className="billing-cycle-badge">
                <span className="billing-label">Billing Cycle</span>
                <span className="billing-value">{billingCycle}</span>
              </p>
            </div>

            <div className="voice-status">
              <span className="voice-status-dot" />
              {status}
            </div>
          </div>
        </header>


        <section className="voice-usage-section">

          <div className="agent-usage-grid">
          {/* Plan Details */}
          <SectionCard
            title="Plan Details"
            icon={ChartGantt}
            className="mb-2"
          >
            <Card className="max-w-0">
              <div className="d-flex justify-between py-1 border-bottom">
                <span className="text-muted">Plan</span>

                <span className="voice-badge">
                  {plan.name}
                </span>
              </div>

              <div className="d-flex justify-between py-1 border-bottom">
                <span className="text-muted">
                  Included minutes
                </span>

                <span className="fw-semibold">
                  {plan.includedMinutes.toLocaleString()} min
                </span>
              </div>

              <div className="d-flex justify-between py-1 border-bottom">
                <span className="text-muted">
                  Overage rate
                </span>

                <span className="fw-semibold">
                  ₹{plan.overageRate} / min
                </span>
              </div>

              <div className="d-flex justify-between py-1">
                <span className="text-muted">
                  Monthly cap
                </span>

                <span className="fw-semibold">
                  ₹{plan.monthlyCap.toLocaleString()}
                </span>
              </div>
            </Card>
          </SectionCard>

          {/* Usage */}
          <SectionCard
            title="Minutes Usage"
            icon={Clock}
            className="mb-2"
          >
            <Card className="max-w-0">
              <div className="voice-metrics-grid">
                <div className="voice-metric-box">
                  <div className="text-sm text-muted">
                    Used
                  </div>

                  <div className="text-lg fw-semibold text-primary">
                    {usage.usedMinutes}

                    <span className="text-sm text-muted ml-0-5">
                      min
                    </span>
                  </div>

                  <div className="text-xs text-muted">
                    of {plan.includedMinutes.toLocaleString()} included
                  </div>
                </div>

                <div className="voice-metric-box">
                  <div className="text-sm text-muted">
                    Remaining
                  </div>

                  <div className="text-lg fw-semibold text-primary">
                    {usage.remainingMinutes}

                    <span className="text-sm text-muted ml-0-5">
                      min
                    </span>
                  </div>

                  <div className="text-xs text-muted">
                    until overage kicks in
                  </div>
                </div>

                <div className="voice-metric-box">
                  <div className="text-sm text-muted">
                    Extra Minutes
                  </div>

                  <div className="text-lg fw-semibold text-primary">
                    {usage.extraMinutes}

                    <span className="text-sm text-muted ml-0-5">
                      min
                    </span>
                  </div>

                  <div className="text-xs text-muted">
                    no overage this cycle
                  </div>
                </div>
              </div>

              <div className="voice-progress-section">
                <div className="d-flex justify-between text-sm mb-1">
                  <span className="text-muted">
                    Usage progress
                  </span>

                  <span className="text-accent fw-semibold">
                    {usage.usagePercentage}%
                  </span>
                </div>

                <div className="voice-progress-track">
                  <div
                    className="voice-progress-fill"
                    style={{
                      width: `${usage.usagePercentage}%`,
                    }}
                  />
                </div>
              </div>
            </Card>
          </SectionCard>

         
          </div>
          <div className="agent-usage-chart-section">
          <SectionCard
            title="Usage Chart"
            icon={ChartNoAxesCombinedIcon}
          >
            <AgentUseageChart />
          </SectionCard>
          {/* Billing */}
          <SectionCard
            title="Billing Estimate"
            className="d-flex flex-column voice-billing-section-card"
          >
            <Card className="max-w-0 flex-grow-1">
              <div className="voice-billing-grid">
                <div className="voice-metric-box voice-highlight">
                  <div className="text-sm text-muted">
                    Estimated Total Bill
                  </div>

                  <div className="text-xl fw-semibold text-accent">
                    ₹{billing.estimatedBill.toLocaleString()}
                  </div>

                  <div className="text-xs text-muted">
                    Based on current usage
                  </div>
                </div>

                <div className="voice-metric-box">
                  <div className="text-sm text-muted">
                    Estimated Overage
                  </div>

                  <div className="text-xl fw-semibold text-primary">
                    ₹{billing.estimatedOverage.toLocaleString()}
                  </div>

                  <div className="text-xs text-muted">
                    0 extra minutes used
                  </div>
                </div>

                <div className="voice-metric-box">
                  <div className="text-sm text-muted">
                    Monthly Cap
                  </div>

                  <div className="text-xl fw-semibold text-primary">
                    ₹{billing.monthlyCap.toLocaleString()}
                  </div>

                  <div className="text-xs text-muted">
                    ₹{billing.remainingCap.toLocaleString()} headroom left
                  </div>
                </div>

                <div className="voice-metric-box">
                  <div className="text-sm text-muted">
                    Overage Rate
                  </div>

                  <div className="text-xl fw-semibold text-primary">
                    ₹{billing.overageRate}/min
                  </div>

                  <div className="text-xs text-muted">
                    Applies after {plan.includedMinutes.toLocaleString()} min
                  </div>
                </div>
              </div>
            </Card>
          </SectionCard>
          </div>
        </section>
      </div>
    </PageContainer>
  );
}